import { render, staticRenderFns } from "./AddOrUpdateMissionBlockForm.vue?vue&type=template&id=16f10e00"
import script from "./AddOrUpdateMissionBlockForm.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateMissionBlockForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports